import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth-guard.service';
import { ProfileComponent } from './components/profile/profile.component';
import { DeactivateComponent } from './components/deactivate/deactivate.component';

const routes = [
  {
    path: 'profile',
    canActivate: [AuthGuard],
    component: ProfileComponent,
  },
  {
    path: 'deactivate',
    // canActivate: [AuthGuard],
    component: DeactivateComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
